import { axiosClient } from '@/lib/axios';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { GetUserSharesResponse } from './updateProfileInfo';

export type IndirectHolding = {
  company_id: number;
  company_name: string;
  indirect_ownership: number;
  via: {
    company_id: number;
    company_name: string;
    user_ownership: number;
    company_ownership: number;
    indirect_ownership: number;
  }[];
};

export type UserSharesResponse = {
  data: GetUserSharesResponse['data'][];
  indirect_holdings?: IndirectHolding[];
};

export const getUserShares = async (): Promise<UserSharesResponse> => {
  const { data } = await axiosClient.get<UserSharesResponse>(`/user-shares`);
  return data;
};

type UseGetUserSharesOptions = {
  config?: Partial<UseQueryOptions<UserSharesResponse>>;
};

export const useGetUserShares = ({ config }: UseGetUserSharesOptions) => {
  return useQuery({
    queryKey: ['user-shares', 'holdings'],
    queryFn: getUserShares,
    ...config,
  });
};
